import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { pascalCase } from 'change-case';
import type { TOC } from '@ember/component/template-only';
import type RouterService from '@ember/routing/router-service';
import type { Collection, DocsService, Page } from 'kolay';
export class Nav extends Component {
    @service('kolay/docs')
    docs: DocsService;
    static{
        template(`
    <nav id="side-nav">
      <Pages @item={{this.docs.tree}} />
    </nav>
    <style>
      nav#side-nav { min-width: 150px; ul { padding-left: 0.5rem; list-style: none; line-height:
      1.75rem; } }
    </style>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
function isCollection(x1: Page | Collection): x is Collection {
    return 'pages' in x1;
}
function nameFor(x1: Page) {
    // We defined componentName via json file
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ('componentName' in x1) {
        return `${x1.componentName}`;
    }
    if (x1.path.includes('/components/')) {
        return `<${pascalCase(x1.name)} />`;
    }
    return x1.name;
}
const Pages: TOC<{
    Args: {
        item: Page | Collection;
    };
}> = template(`
  <ul>
    {{#if (isCollection @item)}}
      {{#each @item.pages as |page|}}
        <li>
          {{#if (isCollection page)}}
            {{page.name}}
          {{/if}}

          <Pages @item={{page}} />
        </li>
      {{/each}}
    {{else}}
      <a href={{@item.path}}>{{nameFor @item}}</a>
    {{/if}}
  </ul>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export class TopNav extends Component {
    @service('kolay/docs')
    docs: DocsService;
    @service
    router: RouterService;
    get groups() {
        return this.docs.availableGroups.map((groupName1)=>{
            if (groupName1 === 'root') return {
                text: 'Home',
                value: '/'
            };
            return {
                text: groupName1,
                value: `/${groupName1}`
            };
        });
    }
    isActive = (subPath1: string)=>{
        if (subPath1 === '/') return false;
        return this.router.currentURL?.startsWith(subPath1);
    };
    static{
        template(`
    <nav id="group-nav">
      <ul>
        {{#each this.groups as |group|}}
          <li>
            <a href={{group.value}} class={{if (this.isActive group.value) "active"}}>
              {{group.text}}
            </a>
          </li>
        {{/each}}
      </ul>
    </nav>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
